import React, {useState} from 'react';
import NavBarLeft from '../../navBar/NavBarLeft';
import NavBarTop from '../../navBar/NavBarTop';
import Settingtools from './Settingtools';
import SettingChart from './chart/SettingChart';
import MadeByBRB from '../dashboard/MadeByBRB';

const Settings = () => {
    const [searchTerm, setSearchTerm] = useState('');
    return (
        <main className='w-full h-screen flex items-start'>
            <div className='w-2/12 h-full hidden lg:block '>
                <NavBarLeft/>
            </div>
            <div className='flex-1 flex flex-col justify-between'>
                <div className='h-16'>
                    <NavBarTop/>
                </div>
                <div className='p-4 h-20 lg:p-8 font-bold text-xl font-color-4 flex justify-between items-center'>
                    <div className='col-span-1'>
                        <h1>Einstellungen</h1>
                    </div>
                    <div className='col-span-1 flex justify-end'>
                        <Settingtools setSearchTerm={setSearchTerm}/>
                    </div>
                </div>
                <div className='mx-8 p-4 border rounded-lg mb-4'>
                    <div className='text-sm font-color-4'>Bauleiter</div>
                    <div className='text-sm font-color-6 mt-2'>Klicken, um Bauleiter zu bearbeiten.</div>
                    <div className='w-full '>
                        <SettingChart searchTerm={searchTerm}/>
                    </div>
                </div>
                <div className='w-full flex justify-end mt-2'>
                    <MadeByBRB/>
                </div>
            </div>
        </main>
    );
}

export default Settings;
